const DEFAULT_IOS_APP_URL = 'https://apps.apple.com/app/id6796181519';
const DEFAULT_ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.mindheart.app';

export const site = {
  iosAppUrl:
    (import.meta.env.VITE_IOS_APP_URL as string | undefined)?.trim() ||
    DEFAULT_IOS_APP_URL,
  androidAppUrl:
    (import.meta.env.VITE_ANDROID_APP_URL as string | undefined)?.trim() ||
    DEFAULT_ANDROID_APP_URL,
  supportEmail:
    (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() ||
    'omnivatissynergy@gmail.com',
  privacyUrl: '/privacy',
  termsUrl: '/terms',
  supportUrl: '/support',
  logoUrl: '/iconLight.svg',
};

export type SiteConfig = typeof site;
